import { createContext, useContext } from "react";

import type APIHelper from "@/Api/APIHelper";

export const ApiHelperContext = createContext<APIHelper | null>(null);

export function useApiHelper(): APIHelper {
	const apiHelper = useContext(ApiHelperContext);
	if (!apiHelper) {
		throw new Error("useApiHelper must be used within ApiHelperContext");
	}
	return apiHelper;
}
